import { fireOnce, trackStructuredEvent } from 'src/analytics';
import { getCategory } from 'src/interviews/analytics';
import type { MiniInterviewType } from 'src/packages/polaris/types';

export const trackProductClick = (args: {
  impressionId: string;
  url: string;
  interviewType: MiniInterviewType;
  order: number;
  moduleLocation: string;
}) =>
  trackStructuredEvent({
    action: 'product-card-click',
    category: `${getCategory(args.interviewType)}-${args.moduleLocation}`,
    property: args.url,
    label: args.impressionId,
    value: args.order,
  });

export const trackProductViewed = (args: {
  impressionId: string;
  url: string;
  interviewType: MiniInterviewType;
  order: number;
  moduleLocation: string;
}) => {
  const event = {
    action: 'product-card-viewed',
    category: `${getCategory(args.interviewType)}-${args.moduleLocation}`,
    property: args.url,
    label: args.impressionId,
    value: args.order,
  };
  fireOnce(() => {
    trackStructuredEvent(event);
  }, `${event.action}-${event.category}-${event.property}-${event.label}`);
};
